export function ChangeLang(nameR: string, nameK: string) {
  const lang = JSON.parse(localStorage.getItem('currentLang') as string)
  return lang?.lng === 'ru' ? nameR || nameK : nameK || nameR
}
